import { pick } from 'ramda';

export default pick([
  'alt',
  'crossorigin',
  'height',
  'ismap',
  'longdesc',
  'sizes',
  'src',
  'srcset',
  'usemap',
  'width',
]);
